import styled from 'styled-components'
import { socials } from 'config/constants/exchange'
import PageSection from 'components/PageSection'
import { Button, Flex, Heading, Link, Text } from '@pancakeswap/uikit'
import { NextLinkFromReactRouter } from 'components/NextLink'
import { PageMeta } from 'components/Layout/Page'
import Hero from './components/Hero'
import MetricsSection from './components/MetricsSection'




const StyledHeroSection = styled(PageSection)`
  margin-top: 16px;
  
  ${({ theme }) => theme.mediaQueries.md} {
    margin-top: 20px;
  }
`


const Home: React.FC = () => {

  return (
    <>
      <PageMeta />

      <StyledHeroSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        // background={
        //   theme.isDark
        //     ? 'radial-gradient(103.12% 50% at 50% 50%, #262626 0%, #171717 100%)'
        //     : 'linear-gradient(139.73deg, #262626 0%, #fefefe 100%)'
        // }
        index={2}
        hasCurvedDivider={false}
        marginBottom="10px"
      >
        <Hero />
      </StyledHeroSection>
      <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        // background={
        //   theme.isDark
        //     ? 'linear-gradient(180deg, #090909 22%, #202020 100%)'
        //     : 'linear-gradient(180deg, #FFFFFF 22%, #D7CAEC 100%)'
        // }
        index={2}
        hasCurvedDivider={false}
      >
        <Flex mt="10px" justifyContent="center" alignItems="center" flexDirection="column">
          <Heading color='dark' mb="10px" textAlign="center" scale="xl">
            The Next Generation of Defarm on <br />Rices Network
          </Heading>
          <Text color='dark' mb="10px" textAlign="center">
            Seed is committed to art and farming Farmer Protocal to seed and trees solutions to its RWAs on the blockchain
          </Text>
          <img src="../images/group-rices.png" alt='seed' />
        </Flex>
      </PageSection>
      <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        // background={
        //   theme.isDark
        //     ? 'linear-gradient(180deg, #090909 22%, #202020 100%)'
        //     : 'linear-gradient(180deg, #FFFFFF 22%, #D7CAEC 100%)'
        // }
        index={2}
        hasCurvedDivider={false}
      >
        <MetricsSection />
      </PageSection>


      <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        // background={
        //   theme.isDark
        //     ? 'linear-gradient(180deg, #090909 22%, #202020 100%)'
        //     : 'linear-gradient(180deg, #FFFFFF 22%, #D7CAEC 100%)'
        // }
        index={2}
        hasCurvedDivider={false}
      >
        <Flex mt="48px" justifyContent="center" alignItems="center" flexDirection="column">
          <Heading color='dark' mb="10px" textAlign="center" scale="xl">
            Unlock the Full Potential of DeFi with Rice Network:
          </Heading>
          <Text color='dark' mb="10px" textAlign="center">
            Experience the power of community ownership, global governance,<br /> and explore infinite use cases within the Rice network ecosystem.
          </Text>
          <NextLinkFromReactRouter to="/swap" >
            <Button mt="10px">Buy Rices Network (RICE)</Button>
          </NextLinkFromReactRouter>
        </Flex>
        <Flex justifyContent="center" mt="48px" >
          {socials.map((social, index) => {
            const iconProps = {
              width: "28px",
              color: "#fff",
              style: { cursor: "pointer" },
            };
            const Icon = social.icon;
            return (
              <Link external key={social.label} href={social.href} aria-label={social.label} mr="16px">
                <Icon {...iconProps} />
              </Link>
            );
          })}
        </Flex>
      </PageSection>

    </>
  )
}

export default Home
